/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Mode {
    ELOFLEET = 'elofleet',
    ELOFUSION = 'elofusion',
    ELOSHIELD = 'eloshield'
}


export function instanceOfMode(value: any): boolean {
    for (const key in Mode) {
        if (Object.prototype.hasOwnProperty.call(Mode, key)) {
            if (Mode[key as keyof typeof Mode] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ModeFromJSON(json: any): Mode {
    return ModeFromJSONTyped(json, false);
}

export function ModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Mode {
    return json as Mode;
}

export function ModeToJSON(value?: Mode | null): any {
    return value as any;
}

export function ModeToJSONTyped(value: any, ignoreDiscriminator: boolean): Mode {
    return value as Mode;
}

